import React from 'react'
import '../../kenoGame.scss'

const KenoFairnessModalResult = (roundHashDetails) => {
  const userNumbers = roundHashDetails?.result
  const numArray1 = Array.from({ length: 40 }, (_, i) => i + 1)
  return (
    <div className='row game-row gx-0 border-0 h-auto'>
      <div className=' game-area-col '>
        <div className='keno-game-elements' style={{ padding: '18px 18px 0 12px' }}>
          <div className='keno-numbers-container d-grid mx-auto position-relative keno-fairness-modal-result'>
            {numArray1.map(ball => (
              <div
                className={`keno-grid-item d-flex align-items-center justify-content-center
                ${userNumbers?.includes(ball) ? 'keno-select-box' : ''}`}
                key={ball}
              >
                {ball}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default KenoFairnessModalResult
